module.exports = __webpack_public_path__ + "static/gayle_hibbert-d3f54315be609d92ab8cffe7eb0b506c.png";